export const videoPlaying = headerText => ({
  type: '[View] Video',
  data: {
    ...(headerText ? { component_heading: headerText } : {}),
  },
});
